export const fullTeamArray = [
	{
	  id: "0",
	  name: "Daniel Dobrzensky",
	  pronouns: "He/him",
	  role: "UX Engineer",
	  team: "Product Design",
	  location: "Oakland!",
	  timezone: "America/Los_Angeles",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/daniel_d_avatar.png?raw=true",
	},
	{
	  id: 1,
	  name: "Mani Singh",
	  pronouns: "He/Him",
	  role: "Engineering Manager",
	  team: "Engineering",
	  location: "San Francisco",
	  timezone: "America/Los_Angeles",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/amber_scott_avatar.png?raw=true",
	},
	{
	  id: 2,
	  name: "Yesenia Lopez",
	  role: "Implementation Manager",
	  team: "Implementation",
	  location: "San Francisco",
	  timezone: "America/Los_Angeles",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/bruce_lopez_avatar.png?raw=true",
	},
	{
	  id: 3,
	  name: "Bobbi Cooper",
	  pronouns: "They/them",
	  role: "Product Manager",
	  team: "Product",
	  location: "San Francisco",
	  timezone: "America/Los_Angeles",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/carolyn_cooper_avatar.png?raw=true",
	},
	{
	  id: 4,
	  name: "Gabriel Campbell",
	  pronouns: "He/him",
	  role: "Senior Software Engineer",
	  team: "Engineering",
	  location: "San Francisco",
	  timezone: "America/Los_Angeles",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/gabriel_campbell_avatar.png?raw=true",
	},
	{
	  id: 5,
	  name: "Isabella Peterson",
	  pronouns: "She/her",
	  role: "Software Engineer",
	  team: "Engineering",
	  location: "San Francisco",
	  timezone: "America/Los_Angeles",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/isabella_peterson_avatar.png?raw=true",
	},
	{
	  id: 6,
	  name: "Janice Edwards",
	  pronouns: "She/her",
	  role: "Enterprise Account Executive",
	  team: "Sales",
	  location: "San Francisco",
	  timezone: "America/Los_Angeles",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/janice_edwards_avatar.png?raw=true",
	},
	{
	  id: 7,
	  name: "Joyce Sanders",
	  pronouns: "She/her",
	  role: "Product Marketing",
	  team: "Marketing",
	  location: "New York",
	  timezone: "America/New_York",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/joyce_sanders_avatar.png?raw=true",
	},
	{
	  id: 8,
	  name: "Kathleen Bell",
	  pronouns: "She/her",
	  role: "Sales Development Representative",
	  team: "Sales",
	  location: "Austin",
	  timezone: "America/Chicago",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/kathleen_bell_avatar.png?raw=true",
	},
	{
	  id: 9,
	  name: "Kayla Walker",
	  pronouns: "She/her",
	  role: "Enterprise Account Executive",
	  team: "Sales",
	  location: "San Francisco",
	  timezone: "America/Los_Angeles",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/kayla_walker_avatar.png?raw=true",
	},
	{
	  id: 10,
	  name: "Maria Bailey",
	  pronouns: "She/her",
	  role: "Support Technical Specialist",
	  team: "Customer Support",
	  location: "San Francisco",
	  timezone: "America/Los_Angeles",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/maria_bailey_avatar.png?raw=true",
	},
	{
	  id: 11,
	  name: "Rai Parker",
	  pronouns: "They/them",
	  role: "Customer Support Specialist",
	  team: "Support",
	  location: "New York",
	  timezone: "America/New_York",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/raymond_parker_avatar.png?raw=true",
	},
	{
	  id: 12,
	  name: "Ronda Cruz",
	  pronouns: "She/her",
	  role: "Customer Success Director",
	  team: "Customer Success",
	  location: "Austin",
	  timezone: "America/Chicago",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/ronald_cruz_avatar.png?raw=true",
	},
	{
	  id: 13,
	  name: "Theresa Moore",
	  pronouns: "She/her",
	  role: "Customer Service Manager",
	  team: "Customer Success",
	  location: "San Francisco",
	  timezone: "America/Los_Angeles",
	  imgUrl: "https://github.com/dano707/world-clock/blob/main/temp/assets/avatars/theresa_moore_avatar.png?raw=true",
	},
  ];
  